import {
  DatePicker,
  DateValidationError,
  LocalizationProvider,
  PickerChangeHandlerContext,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { startOfMonth } from 'date-fns';
import { useState } from 'react';

import { sprinkles } from '@design-system/sprinkles.css';
import { fontFamily } from '@design-system/tokens';

import { OtpRevenue } from './OtpRevenue';
import { SubscriptionRevenue } from './SubscriptionRevenue';

type DashboardProps = {
  creatorId: number;
};

export const Dashboard: React.FC<DashboardProps> = ({ creatorId }) => {
  const [date, setDate] = useState(startOfMonth(new Date()));
  const [error, setError] = useState(false);

  const handleDateChange = (
    value: Date | null,
    context: PickerChangeHandlerContext<DateValidationError>,
  ) => {
    if (!context.validationError && value) {
      setDate(value);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="px-[30px] py-[40px] bg-white rounded-xl">
        <DatePicker
          views={['year', 'month']}
          openTo="month"
          value={date}
          onChange={handleDateChange}
          minDate={new Date('2023-08-01')}
          disableFuture
          slotProps={{
            field: {
              readOnly: true,
            },
            popper: {
              sx: {
                '& .MuiPickersMonth-monthButton': {
                  fontFamily: fontFamily.visuelt,
                },
                '& .MuiPickersYear-yearButton': {
                  fontFamily: fontFamily.visuelt,
                },
                '& .MuiPickersCalendarHeader-label': {
                  fontFamily: fontFamily.visuelt,
                },
              },
            },
            textField: {
              InputProps: {
                sx: { fontFamily: fontFamily.visuelt },
              },
              error,
              helperText: error
                ? 'The data is only available since August 2023.'
                : undefined,
            },
          }}
          className={sprinkles({ fontFamily: 'visuelt' })}
        />
        <section className="mt-[30px]">
          <SubscriptionRevenue date={date} creatorId={creatorId} />
        </section>
        <section className="mt-[30px]">
          <OtpRevenue date={date} creatorId={creatorId} />
        </section>
      </div>
    </LocalizationProvider>
  );
};
